import React, { useState, useEffect, useRef } from "react";
import "./BusinessThreeAboutUs.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import CountUp from "react-countup";

const BusinessThreeAboutUs = ({ id }) => {
  const counterRef = useRef(null);
  const [counterKey, setCounterKey] = useState(Date.now());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Update key to restart counters
            setCounterKey(Date.now());
          }
        });
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <div style={{ backgroundColor: "var(--white-color)" }} id={id}>
      <div className="large_padding_div"></div>
      <div className="large_padding_div"></div>

      <div className="container">
        <div className="business-three-hero-hero-section">
          <div className="business-three-hero-hero-left">
            <OwlCarousel
              className="business-three-hero-owl-theme"
              loop
              autoplay
              margin={10}
              items={1}
            >
              <div className="business-three-hero-carousel-item">
                <div className="business-three-hero-image-wrapper">
                  <img
                  src="https://hifimart.com/wp-content/uploads/2024/10/iStock-177100713.jpg"
                    alt="Carousel 1"
                  />
                </div>
                <div className="business-three-hero-carousel-text">
                  <h1>
                    Turn Up the Volume, Light Up the Vibe
                  </h1>
                  <br />
                  <p>
                    We mix sound and shine to turn every space into a celebration zone — powered by Us, driven by you.
                  </p>
                </div>
              </div>
              <div className="business-three-hero-carousel-item">
                <div className="business-three-hero-image-wrapper">
                  <img
                  src="https://img.freepik.com/free-photo/back-view-crowd-fans-watching-live-performance-music-concert-night-copy-space_637285-544.jpg"
                    alt="Carousel 2"
                  />
                </div>
                <div className="business-three-hero-carousel-text">
                  <h1>The Sound of Celebration Starts Here</h1>
                  <br />
                  <p>
                    Speakers, lights, and everything in between — we bring your moments to life with tech that feels alive..{" "}
                  </p>
                </div>
              </div>
            </OwlCarousel>
            <div className="business-three-hero-search-bar">
              <input type="text" placeholder="Find in and around..." />
              <button>Search</button>
            </div>
          </div>
          <div className="business-three-hero-hero-right">
            <div className="business-three-hero-hero-card">
              <img
              src="https://t4.ftcdn.net/jpg/09/58/40/17/240_F_958401731_08xtH6XT0vsIAZM73Gj71QsFOEKdRZKJ.jpg"
                alt="Eco-Friendly Solutions"
              />
              <div>
                {/* <h3>Nature-Friendly Solutions</h3> */}
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
            <div className="business-three-hero-hero-card">
              <img
              src="https://avstore.in/cdn/shop/articles/AVStore-Sealed-Ported-Subwoofer.jpg?v=1699532465&width=600"
                alt="Professional Dry Cleaning"
              />
              <div>
                {/* <h3>Plug In. Glow Up. Vibe Out.</h3> */}
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
            <div className="business-three-hero-hero-card">
              <img
              src="https://syslabme.com/wp-content/uploads/2025/01/Pro_Lighting_5_4K-1536x864.webp"
                alt="Quality Laundry Services"
              />
              <div>
                {/* <h3>Lighting Up</h3> */}
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={counterRef} className="home-three-hero-banner-below-parent">
        <div className="container">
          <div className="row">
          <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">groups</span> &nbsp;
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`customers-${counterKey}`}
                  start={0}
                  end={5000}
                  duration={3}
                  suffix="+"
                />
                <span> Customers</span>
              </h5>
            </div>
           
            <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">wifi</span> &nbsp;
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`services-${counterKey}`}
                  start={0}
                  end={150}
                  duration={4}
                  suffix="+"
                />
                <span> Services</span>
              </h5>
            </div>
            <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">home_work</span>{" "}
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`cities-${counterKey}`}
                  start={0}
                  end={24}
                  duration={4}
                  suffix="+"
                />
                <span> Cities</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessThreeAboutUs;
